import auth from "./auth";
import axios from "axios";

let loginRequest = {
  scopes: ["openid", "profile", "User.Read"],
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
};

export default {
  async searchUser(searchText){
    var result = null;
    try {
      var accessToken = await acquireToken();

      if (accessToken == null) {
        return null;
      }

      let response = await callGraph(
        `https://graph.microsoft.com/v1.0/users?$filter=startswith(userprincipalname,'${searchText}')`,
        accessToken,
        "json"
      );

      result = response.value;
    }
    catch(ex){
      console.error(ex);
    }

    return result;
    
  },
  async getAppRoleAssignments() {
    var roles = null;
    try {
      var accessToken = await acquireToken();

      if (accessToken == null) {
        return null;
      }

      let response = await callGraph(
        "https://graph.microsoft.com/beta/me/approleassignments?$filter=resourceId eq 4dc6511e-3f11-4e17-bad2-e657dd5acdd6",
        accessToken,
        "json"
      );

      let pattern = new RegExp("CARS");

      let graphRoles = response.value.filter(function(x) {
        return x.principalDisplayName.match(pattern);
      });

      roles = graphRoles.map(x => x.principalId);

      console.log({roles});
      //need to allow multiple roles based on users business unit id for approvals
      // if(graphRole.length >= 1){
      //   result = graphRole[0].principalId
      // }
    } catch (error) {
      console.error(error);
    }
    return roles;
  },

  async getSalesAndTechGroup(){
    var accessToken = await acquireToken();

    if (accessToken == null) {
      return null;
    }

    let response = await callGraph(
      "https://graph.microsoft.com/beta/groups/4327c0e4-400e-4a72-8eb7-dca9510f4b03/members",
      accessToken,
      "json"
    );

    let users = response.value.map(v => {return {upn: v.userPrincipalName, dn: v.displayName}});

    return users;
  },
  async getUserProfile() {
    var result = null;
    try {
      var accessToken = await acquireToken();
      if (accessToken == null) {
        return null;
      }

      let response = await callGraph(
        "https://graph.microsoft.com/beta/me/",
        accessToken,
        "json"
      );
      result = response;
    } catch (error) {
      console.error(error);
    }
    return result;
  },

  async getPhoto() {
    var result = null;
    try {
      var accessToken = await acquireToken();

      if (accessToken == null) {
        return null;
      }

      var response = await callGraph(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        accessToken,
        "blob"
      );

      if (response) {
        result = URL.createObjectURL(response);
      }
    } catch (error) {
      console.log("Unable to get user photo", error);
    }
    return result;
  }
};

async function callGraph(apiPath, accessToken, responseType) {
  var result = null;
  try {
    let response = await axios.get(apiPath, {
      headers: { Authorization: `Bearer ${accessToken}` },
      responseType: responseType,
      withCredentials: false
    });
    result = response.data;
  } catch (error) {
    console.error(error);
  }
  return result;
}

async function acquireToken() {
  var msalApp = auth.getMsalApp();
  var loginHint = auth.getLoginHint();

  var account = msalApp.getAccountByUsername(loginHint);
  if (account == null) {
    return null;
  }

  // Set scopes for token request
  const accessTokenRequest = {
    scopes: loginRequest.scopes,
    account: account,
    forceRefresh: loginRequest.forceRefresh,
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI
  };

  let tokenResp;
  try {
    tokenResp = await msalApp.acquireTokenSilent(accessTokenRequest);
  } catch (error) {
    console.error("tokenError", error);
    tokenResp = await msalApp.acquireTokenPopup(accessTokenRequest);
  }

  // Just in case check, probably never triggers
  if (!tokenResp.accessToken) {
    throw new Error("### accessToken not found in response, that's bad");
  }
  return tokenResp.accessToken;
}
